import { useEffect, useRef } from "react";
import {
  Button,
  Flex,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalOverlay,
  Text,
  useDisclosure,
} from "@chakra-ui/react";
import { useCompanySelection } from "src/store/companySelectionState";
import { useLocation } from "react-router-dom";
import { cookieStorage } from "src/utils/cookieStorage";

const CallForwardingNotice = () => {
  const location = useLocation();
  const { activeCompanyObject } = useCompanySelection();
  const contactId = activeCompanyObject?.contactId;
  const isPrimaryUser = activeCompanyObject?.isPrimary || false;
  const cookieKey = `${contactId || "_"}_callforwardingnotice_shown`;
  const hasCallForwardingNoticeShown = () => {
    const cookieValue = cookieStorage.getItemSync(cookieKey);
    return cookieValue === null ? false : cookieValue === "true";
  };
  const sethasCallForwardingNoticeShown = (value: boolean) => {
    cookieStorage.setItemSync(cookieKey, value.toString());
  };
  const { isOpen, onOpen, onClose } = useDisclosure();

  const handleCallForwardingInstructions = () => {
    window.open("https://www.abby.com/forwarding/", "_blank");
  };

  const handleCloseModal = () => {
    sethasCallForwardingNoticeShown(true);
    onClose();
  };

  const AI_CALL_HANDLING_PAGE = "/abby-ai-receptionist/ai-call-handling";
  const AI_ONBOARDING_PAGE = "/abby-ai-receptionist/ai-receptionist-onboarding";
  const prevPathRef = useRef(location.pathname);

  useEffect(() => {
    if (!isPrimaryUser) {
      return;
    }
    const prevPath = prevPathRef.current;
    const currentPath = location.pathname;
    if (
      AI_CALL_HANDLING_PAGE === prevPath &&
      AI_CALL_HANDLING_PAGE !== currentPath &&
      AI_ONBOARDING_PAGE !== currentPath &&
      "/login" !== currentPath &&
      !hasCallForwardingNoticeShown()
    ) {
      onOpen();
    }
    prevPathRef.current = currentPath;
  }, [location.pathname, onOpen]);

  if (hasCallForwardingNoticeShown()) {
    return null;
  }

  return (
    <Modal
      isCentered
      isOpen={isOpen}
      onClose={handleCloseModal}
      closeOnOverlayClick={false}
    >
      <ModalOverlay
        bg={"blackAlpha.700"}
        backdropFilter={"auto"}
        backdropBlur={"5px"}
      />
      <ModalContent
        w={"max-content"}
        h={"max-content"}
        maxW={"max-content"}
        maxH={"max-content"}
        className={"pendo-ai-callforwardingnotice-modal"}
      >
        <ModalCloseButton
          size={"lg"}
          _focus={{ boxShadow: "none", outline: "none" }}
          className={"pendo-ai-callforwardingnotice-modal-closebtn"}
        />
        <ModalBody p={14} overflow={"auto"}>
          <Flex
            direction={{ base: "column", md: "row" }}
            justifyContent={"center"}
            alignItems={"center"}
            gap={4}
          >
            <Text as={"div"}>
              Your AI Receptionist is ready to take calls. Start now:
            </Text>
            <Button
              variant={"purple"}
              w={"max-content"}
              px={2}
              onClick={handleCallForwardingInstructions}
            >
              Call Forwarding Instructions
            </Button>
          </Flex>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default CallForwardingNotice;
